import React from 'react';
import * as TotemActions from '../actions/TotemActions';
import ArticleComponent from './ArticleComponent';

class SlideComponent extends React.Component {
    constructor(props) {
        super(props);
        this.reopenVideoInterval;
        this.state = {
            videoEnded: false,
            hideVideo: false
        };
    }

    readVideo() {
        var that = this;
        var xhr = new XMLHttpRequest(),
            blob;
        // Get the Video file from the server.
        if (this.props.showVideo) {
            xhr.open("GET", this.props.article.videoSrc, true);
            xhr.responseType = "blob";
            xhr.addEventListener("load", function () {
                if (xhr.status === 200) {
                    blob = xhr.response;
                    //putVideoInDb(blob);
                    var URL = window.URL || window.webkitURL;
                    var videoURL = URL.createObjectURL(blob);

                    // Set video src to ObjectURL
                    var videoElement = document.getElementById('video-' + that.props.article.id);
                    if (videoElement) {
                        videoElement.setAttribute("src", videoURL);
                    }
                }
            }, false);
            xhr.send();
        }
    }

    _handleVideoEnded() {
        this.props.videoEnded();
    }

    _handleVideoClick() {
        TotemActions.increaseStatistics(this.props.article.id, 'views');
        this.reopenVideoInterval = setTimeout(() => {
            this.setState({
                hideVideo: false
            });
            this.props.restoreInterval();
        }, 60000);

        this.setState({
            hideVideo: true
        });
        this.props.onClicked();
    }

    _handleBuyButtonClick() {
        TotemActions.increaseStatistics(this.props.article.id, 'clicks');
        clearInterval(this.reopenVideoInterval);
        this.reopenVideoInterval = setTimeout(() => {
            this.setState({
                hideVideo: false
            });
            let timeout = this.props.article.videoSrc ? undefined : 3000;
            this.props.restoreInterval(timeout);
        }, 5000);
    }

    _handleBackButtonClick() {
        this.setState({
            hideVideo: false
        });
        let timeout = this.props.article.videoSrc ? undefined : 3000;
        this.props.restoreInterval(timeout);
    }

    _handleAttendantButtonClick(brandId, articleId) {
        TotemActions.createNotification(brandId, articleId);
    }

    render() {

        let { hideVideo } = this.state;
        //<source src={this.props.article.videoSrc} type={'video/' + this.props.article.videoSrc.split('.').pop()} />
        let cover = this.props.article.videoSrc ?
            <video preload autoPlay id={'video-' + this.props.article.id} width="100%" height="100%" onEnded={this._handleVideoEnded.bind(this)} onClick={this._handleVideoClick.bind(this)}>

            </video>
            :
            <div className="cover-image-container" onClick={this._handleVideoClick.bind(this)}>
                <img width="100%" height="100%" className="cover-image" src={this.props.article.cover} />
            </div>;

        let body = '';

        if (this.props.showVideo && !hideVideo) {
            body = cover;
            this.readVideo();
        } else {
            if (hideVideo) {
                body = <ArticleComponent article={this.props.article} restoreInterval={this.props.restoreInterval} backButtonClicked={this._handleBackButtonClick.bind(this)} ecommerceClicked={this._handleBuyButtonClick.bind(this)} attendantClicked={this._handleAttendantButtonClick.bind(this)} buyClicked={this._handleBuyButtonClick.bind(this)} />;
            }
        }

        return (
            <div className="slide">
                {body}
            </div>
        );
    }
}

export default SlideComponent;



// WEBPACK FOOTER //
// ./src/components/SlideComponent.js